/**
 * Select2.js
 *
 * Simple Select2 component wrapper to play nicely with Bootstrap Pages plugin.
 */

import React, { PureComponent } from 'react';

class Select2 extends PureComponent {
  componentDidMount() {
    if (window.$ && window.$().select2) {
      this.$selectNode = window.$(this.selectNode);
      this.$selectNode.select2({
        placeholder: this.props.placeholder || 'Select an option',
        width: '100%',
      });

      if (this.props.onChange) {
        this.$selectNode.on(
          'select2:select select2:unselecting',
          this.props.onChange
        );
      }
      this.isInitialized = true;
    } else {
      this.isInitialized = false;
      console.warn('$.select2 missing');
    }
  }

  componentDidUpdate(prevProps) {
    if (this.isInitialized) {
      this.$selectNode.select2({
        value: this.props.value,
      });
    }
    if (
      this.isInitialized &&
      this.props.value &&
      prevProps.value !== this.props.value
    ) {
      this.$selectNode.trigger('select2:select');
      if (this.props.onChange) {
        this.props.onChange({
          currentTarget: this.selectNode,
          target: this.selectNode,
          value: this.props.value,
        });
      }
    }
  }

  componentWillUnmount() {
    this.$selectNode.select2('destroy');
  }

  render() {
    const { children, ...otherProps } = this.props;

    return (
      <select {...otherProps} ref={(c) => (this.selectNode = c)}>
        {children}
      </select>
    );
  }
}

export default Select2;
